import ContentParameterSettings from 'features/content-parameter-settings/ContentParameterSettings';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function SiteConfigContentPresentationListDetail() {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.SUPER);

  return (
    <SiteConfigPage title="Content Parameters">
      <ContentParameterSettings />
    </SiteConfigPage>
  );
}

export default SiteConfigContentPresentationListDetail;
